export const partyAreasData = () => {
  return [
    {
      title: "all exclusive party areas",
      color: "",
      earlyBird: "",
      regular: "",
      class: "allAreas",
      map: require("@/assets/images/GroupMaps/main-map.svg"),
      active: true,
    },
    {
      title: "american lounge tables",
      color: "#b292b7",
      // earlyBird: "105",
      // regularOnly: "105",
      regularOnlyStart: "110",
      class: "outfieldMezzanine",
      map: require("@/assets/images/GroupMaps/empty-map.svg"),
      description: "",
      sections: "Field Level<span>(first baseline)</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$110</span><br>each table includes $120 table credit for food & beverage",
      legal:
        "Must be booked in increments of 4. Minimum group requirement is 12 tickets (3 tables).",
      carousel: [
        // require("@/assets/images/PartyAreas/dugout-lounge-tables/dugout-lounge-tables-01.jpeg"),
        // require("@/assets/images/PartyAreas/dugout-lounge-tables/dugout-lounge-tables-02.jpeg"),
        require("@/assets/images/PartyAreas/dugout-lounge-tables/dugout-lounge-tables-03.jpeg"),
        require("@/assets/images/PartyAreas/dugout-lounge-tables/dugout-lounge-tables-04.jpeg"),
      ],
      active: false,
    },
    {
      title: "Teremana Terrace",
      color: "#54338D",
      // earlyBird: "70",
      // regular: "75",
      regularOnlyStart: "75",
      class: "wildRagDeck",
      map: require("@/assets/images/GroupMaps/termania.svg"),
      description:
        "Overlooking center field, this lively and large area is the only non-premium space in the ballpark that offers table service. Conveniently located through the gates, these taco tables seat four and your ticket comes with $25 to use for in-seat service or at any concession stand.",
      sections: "SECTIONS <span>134 & 135</span>",
      capacity: "4-156",
      // price: "price per 4 tickets <span>$000.00</span>.<br>includes <span>$25</span> in loaded value per ticket.",
      price:
        "price per ticket starting at <span>$75</span>",
      legal:
        "Sold in increments of 4 seats. Minimum group requirement is 12 tickets (3 tables).",
      carousel: [
        // require("@/assets/images/PartyAreas/rag-deck/wild-rag-deck-01.jpeg"),
        require("@/assets/images/PartyAreas/rag-deck/wild-rag-deck-02.jpeg"),
        require("@/assets/images/PartyAreas/rag-deck/wild-rag-deck-03.jpeg"),
        require("@/assets/images/PartyAreas/rag-deck/wild-rag-deck-04.jpeg"),
        // require("@/assets/images/PartyAreas/rag-deck/wild-rag-deck-05.jpeg"),
        require("@/assets/images/PartyAreas/rag-deck/wild-rag-deck-06.jpeg"),
      ],
      active: false,
    },
    {
      title: "sky box picnic",
      color: "#96BE63",
      // earlyBird: "17",
      regularOnlyStart: "47.50",
      // tbd: "TBD",
      class: "skyBox",
      map: require("@/assets/images/GroupMaps/skybox-picnic.svg"),
      description:
        "This spacious area located in a more exclusive area behind the seats in left field, offers plenty of room for your group to mingle with convenient access to concessions. The perfect space to host a semi-private picnic (groups of 50-225) with a spectacular view of the game.",
      sections: "SECTIONS <span>SB1-SB4</span>",
      capacity: "50-225",
      price:
        "price per ticket starting at <span>$47.50</span>",
      // price: "price per 4 tickets <span>$000.00</span>.",
      // legal: "(Sold in increments of 4 seats)",
      carousel: [require("@/assets/images/PartyAreas/sky-box/sky-box-01.jpeg")],
      active: false,
    },
    {
      title: "budweiser sky porch rocking chairs",
      htmltitle: "budweiser sky porch<br> rocking chairs",
      color: "#A5629B",
      // earlyBird: "39",
      regularOnlyStart: "50",
      class: "wildRagDeck",
      map: require("@/assets/images/GroupMaps/rocking-chairs.svg"),
      description:
        "Fun area, great views and rocking chairs! This laid-back space is designed to feel like a Texas porch and includes easy access to the Karbach concession area for groups of 10 or 20.",
      sections: "SECTIONS <span>201-204</span>",
      capacity: "10-20",
      price:
        "price per ticket starting at <span>$50</span>",
      // price: "price per 4 tickets <span>$000.00</span>.<br>includes <span>$25</span> in loaded value per ticket.",
      // legal: "(Sold in increments of 4 seats)",
      carousel: [
        require("@/assets/images/PartyAreas/rocking-chairs/rocking-chairs-01.jpeg"),
        require("@/assets/images/PartyAreas/rocking-chairs/rocking-chairs-02.jpeg"),
        require("@/assets/images/PartyAreas/rocking-chairs/rocking-chairs-03.jpeg"),
        require("@/assets/images/PartyAreas/rocking-chairs/rocking-chairs-04.jpeg"),
        require("@/assets/images/PartyAreas/rocking-chairs/rocking-chairs-05.jpeg"),
        require("@/assets/images/PartyAreas/rocking-chairs/rocking-chairs-06.jpeg"),
      ],
      active: false,
    },
    {
      title: "budwiser sky porch balcony",
      // htmltitle: "",
      color: "#A5629B",
      // earlyBird: "",
      regularOnlyStart: "42.50",
      // tbd: "TBD",
      class: "upperDeckTerrace",
      map: require("@/assets/images/GroupMaps/rocking-chairs.svg"),
      description:
        "Party area with 1.5 hours of food and beverage service and access to group picnic area.",
      sections: "Sections<span>201-204</span>",
      capacity: "50-200",
      price:
        "price per ticket starting at <span>$42.50</span>",
      // price: "price per 4 tickets <span>$000.00</span>.",
      // legal: "(Sold in increments of 4 seats)",
      carousel: [
        require("@/assets/images/PartyAreas/sky-porch/sky-porch-1.jpg"),
        require("@/assets/images/PartyAreas/sky-porch/sky-porch-2.jpg"),
      ],
      active: false,
    },
    {
      title: "left field deck picnic",
      color: "#78A3D4",
      // earlyBird: "",
      regularOnlyStart: "32.50",
      // tbd: "TBD",
      class: "leftFieldDeckPicnic",
      map: require("@/assets/images/GroupMaps/left-field-deck.svg"),
      description:
        "With a commanding view from left field, enjoy 1.5 hours of food and beverage service and access to a semi-private group picnic area directly above the seats.",
      sections: "SECTIONS <span>240-244</span>",
      capacity: "50-1,000",
      price:
        "price per ticket starting at <span>$32.50</span>",
      // price: "price per 4 tickets <span>$000.00</span>.",
      // legal: "(Sold in increments of 4 seats)",
      carousel: [
        require("@/assets/images/PartyAreas/outfield-picnic-pavilion/outfield-picnic-pavilion-02.jpeg"),
        require("@/assets/images/PartyAreas/outfield-picnic-pavilion/outfield-picnic-pavilion-03.jpeg"),
        require("@/assets/images/PartyAreas/outfield-picnic-pavilion/outfield-picnic-pavilion-04.jpeg"),
        require("@/assets/images/PartyAreas/outfield-picnic-pavilion/outfield-picnic-pavilion-05.jpeg"),
        require("@/assets/images/PartyAreas/outfield-picnic-pavilion/outfield-picnic-pavilion-06.jpeg"),
        require("@/assets/images/PartyAreas/outfield-picnic-pavilion/outfield-picnic-pavilion-07.jpeg"),
        require("@/assets/images/PartyAreas/outfield-picnic-pavilion/outfield-picnic-pavilion-01.jpeg"),
      ],
      active: false,
    },
  ];
};
